module.exports = __webpack_public_path__ + "static/media/31_plantilla_rec_combo_simple_cf_gaseosas_pet_2_5_fn.647740d6.png";